import React, { forwardRef } from "react";
import ReactModal from "react-modal";

import Typography from "../Typography/Typography";

import CloseButton from "./CloseButton";
import { ModalProps } from "../Modal/Modal.types";
import { ModalContentWrapper, ModalCrossIconWrapper, ModalOverlayWrapper, ModalSectionWrapper } from "./Modal.styles";
import zIndexList from "../../constants/zIndexList";
if (typeof document !== "undefined") {
    ReactModal.setAppElement(document.getElementById("__next") ?? document.body);
}

interface ModalCrossIconProps {
    onClick?: any;
    id?: string;
}

export const ModalCrossIcon = ({ onClick, id }: ModalCrossIconProps) => {
    return (
        <ModalCrossIconWrapper onClick={onClick} id={id ? `${id}--closeBtn` : ""}>
            <CloseButton />
        </ModalCrossIconWrapper>
    );
};

const Modal = forwardRef<HTMLDivElement, ModalProps>((props: ModalProps, ref) => {
    const {
        children,
        onAfterClose,
        onToggle,
        id,
        isOpen = false,
        onAfterOpen,
        preventScroll,
        shouldCloseOnEsc = true,
        shouldCloseOnOverlayClick = true,
        showCloseIcon = true,
        renderFooter,
        renderTitle = null,
        size = "wide",
        titleText,
        bodyHeight = "75vh",
        bodyMinHeight,
        showHeader = true,
        padded = true,
        modalSeparationGap = 20,
        blurBackground = false,
        borderRadius,
        fullScreenModal,
        zIndex,
        hideBodyScrollbar = false,
        bodyStyle
    } = props;

    const handleOnClickClose = () => {
        onToggle?.(false);
    };

    return isOpen ? (
        <ReactModal
            id={id}
            onAfterClose={onAfterClose}
            onAfterOpen={onAfterOpen}
            onRequestClose={() => onToggle?.(!isOpen)}
            preventScroll={preventScroll ?? false}
            shouldCloseOnEsc={shouldCloseOnEsc}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            isOpen={isOpen}
            style={{
                overlay: {
                    zIndex: zIndex ?? zIndexList.modal,
                    backdropFilter: `blur(${blurBackground ? 10 : 0}px)`
                },
                content: {
                    zIndex: zIndex ?? zIndexList.modal,
                    // gap: modalSeparationGap,
                    ...(borderRadius && {
                        borderRadius: borderRadius
                    })
                }
            }}
            overlayElement={(htmlProps: any, contentElement) => (
                <ModalOverlayWrapper {...htmlProps}>{contentElement}</ModalOverlayWrapper>
            )}
            contentElement={(htmlProps: any, children) => (
                <ModalContentWrapper
                    {...htmlProps}
                    size={size}
                    padded={padded}
                    fullScreenModal={fullScreenModal}
                    hideBodyScrollbar={hideBodyScrollbar}
                >
                    {children}
                </ModalContentWrapper>
            )}
        >
            {showHeader ? (
                <>
                    {renderTitle ? (
                        renderTitle
                    ) : (
                        <ModalSectionWrapper data-popup-header padded={padded}>
                            {titleText ? (
                                <Typography weight="bold" size="l">
                                    {titleText}
                                </Typography>
                            ) : null}
                            {showCloseIcon ? <ModalCrossIcon onClick={handleOnClickClose} id={id} /> : null}
                        </ModalSectionWrapper>
                    )}
                </>
            ) : null}
            <ModalSectionWrapper
                data-popup-body
                style={{
                    maxHeight: fullScreenModal ? "unset" : bodyHeight,
                    minHeight: bodyMinHeight,
                    ...bodyStyle
                }}
                padded={padded}
            >
                {children}
            </ModalSectionWrapper>
            {renderFooter ? (
                <ModalSectionWrapper
                // data-popup-footer
                >
                    {renderFooter}
                </ModalSectionWrapper>
            ) : null}
        </ReactModal>
    ) : (
        <></>
    );
});

export default Modal;
